export default __webpack_public_path__ + "static/media/29-comfort.a13e1197.png";